import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { RadioContainer } from "../../commons";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import Select from "react-select";
import { CalenderIcon } from "../../Icon";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Label } from "reactstrap";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  getAllCityAction,
  getAllStateAction,
  resetCityList,
  resetStateList,
} from "../../../redux/masterData";
import {
  GetCityListDataPayloadType,
  GetStateListDataPayloadType,
} from "../../../commonTypes/masterDataTypes";
import {
  CityListTypes,
  StateListTypes,
} from "../../../redux/masterData/masterTypes";
import { di, s } from "@fullcalendar/core/internal-common";
import {
  UpdateEWayBillPayloadType,
  UpdateTrasporterEWayBillPayloadType,
} from "../../../commonTypes/invoiceGenerationTypes";
import { EWayBillReviewDataType } from "../../../redux/invoiceGeneration/invoiceGenrationTypes";
import { set } from "date-fns";
import {
  resetEWayBillUpdateError,
  updateTransporterEWayBillDetails,
  updateVehicleEWayBillDetails,
} from "../../../redux/invoiceGeneration";
import { reverseDate } from "../../../utils/commonFunctions";
import { RedErrorIcon } from "../../../assets/images";
const VEHICLE_SECTION_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "vehicle_details",
    name: "Vehicle Details",
  },
  {
    id: "transporter_details",
    name: "Transporter Details",
  },
];
export const MODE = [
  { value: "Road", label: "Road" },
  { value: "Air", label: "Air" },
  { value: "Ship", label: "Ship" },
  { value: "Rail", label: "Rail" },
];
export const REASON_CODE = [
  {
    value: "Due to Break Down",
    label: "Due to Break Down",
  },
  {
    value: "Due to Transshipment",
    label: "Due to Transshipment",
  },
  {
    value: "Others (Pls. Specify)",
    label: "Others (Pls. Specify)",
  },
  {
    value: "First Time",
    label: "First Time",
  },
];
export const VEHICLE_TYPE = [
  { value: "Regular", label: "Regular" },
  { value: "Over Dimensional Cargo", label: "Over Dimensional Cargo" },
];
type AppProps = {
  isOpen: boolean;
  toggleModal: () => void;
  token: string | null;
  dispatchGetAllStateAction: (data: GetStateListDataPayloadType) => void;
  dispatchGetAllCityAction: (data: GetCityListDataPayloadType) => void;
  stateList: StateListTypes[] | [];
  cityList: CityListTypes[] | [];
  stateFetching: boolean;
  countryFetching: boolean;
  eWayBillReviewData: EWayBillReviewDataType;
  eWayBillError: string;
  eWayBillUpdateError: string;
  dispatchResetStateList: () => void;
  dispatchResetCityList: () => void;
  dispatchUpdateVehicleEWayBillDetails: (
    data: UpdateEWayBillPayloadType
  ) => void;
  dispatchUpdateTransporterEWayBillDetails: (
    data: UpdateTrasporterEWayBillPayloadType
  ) => void;
  invoiceId: number;
  clientCode: number;
  type: string;
  dispatchResetEWayBillUpdateError: () => void;
  fetching: boolean;
};
const UpdateEWayBillDetails = ({
  isOpen,
  toggleModal,
  token,
  dispatchGetAllStateAction,
  stateList,
  cityList,
  dispatchGetAllCityAction,
  stateFetching,
  countryFetching,
  eWayBillReviewData,
  eWayBillError,
  eWayBillUpdateError,
  dispatchResetStateList,
  dispatchResetCityList,
  dispatchUpdateVehicleEWayBillDetails,
  invoiceId,
  clientCode,
  type,
  dispatchResetEWayBillUpdateError,
  dispatchUpdateTransporterEWayBillDetails,
  fetching,
}: AppProps) => {
  const [selectSection, setSelectSection] = useState<string>(
    VEHICLE_SECTION_RADIO_OPTIONS[0].id
  );
  const [trasporterId, setTrasporterId] = useState<string>("");
  const [finalStateList, setFinalStateList] = useState<any>([]);

  const [finalCityList, setFinalCityList] = useState<any>([]);
  const [stateSelect, setStateSelect] = useState("");

  const [updateTransporterDetails, setUpdateTransporterDetails] =
    useState<UpdateEWayBillPayloadType>({
      client_code: +clientCode,
      token: token,
      invoice_id: +invoiceId,
      invoice_type: type,
      vehicle_number: "",
      from_state: "",
      from_place: "",
      update_reason_remarks: "",
      transporter_document_number: "",
      transporter_document_date: "",
      transportation_mode: "",
      vehicle_type: "",
      reason_of_update: "",
      type: "",
    });
  useEffect(() => {
    dispatchResetStateList();
    dispatchResetCityList();
    dispatchResetEWayBillUpdateError();
    let finalData: GetStateListDataPayloadType = {
      token,
      country_id: 101,
    };
    dispatchGetAllStateAction(finalData);
  }, []);

  useEffect(() => {
    const finalCityData = cityList?.map((data: any) => {
      return {
        value: data?.name,
        label: data?.name,
      };
    });
    setFinalCityList([...finalCityData]);
  }, [cityList]);

  useEffect(() => {
    const finalStateData = stateList?.map((data: any) => {
      return {
        value: data?.name,
        label: data?.name,
        id: data?.id,
      };
    });
    setFinalStateList(finalStateData);
  }, [stateList]);

  useEffect(() => {
    if (updateTransporterDetails?.transportation_mode !== "Road") {
      setUpdateTransporterDetails({
        ...updateTransporterDetails,
        vehicle_type: "",
      });
    }
  }, [updateTransporterDetails?.transportation_mode]);

  useEffect(() => {
    setUpdateTransporterDetails({
      ...updateTransporterDetails,
      from_state: eWayBillReviewData?.consignor_details?.state_of_consignor,
      from_place: eWayBillReviewData?.consignor_details?.place_of_consignor,
      transporter_document_number:
        eWayBillReviewData?.transportation_details?.transporter_document_number,
      transporter_document_date:
        eWayBillReviewData?.transportation_details?.transporter_document_date,
      transportation_mode:
        eWayBillReviewData?.transportation_details?.transportation_mode,
      vehicle_type: eWayBillReviewData?.transportation_details?.vehicle_type,
      type: "",
      vehicle_number:
        eWayBillReviewData?.transportation_details?.vehicle_number,
    });
  }, [eWayBillReviewData]);

  useEffect(() => {
    if (
      stateSelect ||
      eWayBillReviewData?.consignor_details?.state_id_of_consignor
    ) {
      // setUpdateTransporterDetails({
      //   ...updateTransporterDetails,
      //   from_place: "",
      // });
      let finalData: GetCityListDataPayloadType = {
        token,
        state_id: stateSelect
          ? stateSelect
          : eWayBillReviewData?.consignor_details?.state_id_of_consignor,
      };
      dispatchGetAllCityAction(finalData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateSelect, eWayBillReviewData]);

  const handleSetSelectSection = (value: string) => {
    dispatchResetEWayBillUpdateError();
    setSelectSection(value);
  };
  const handleChangeTransporterId = (e: any) => {
    setTrasporterId(e.target.value);
  };
  const handleSubmitDetails = () => {
    dispatchResetEWayBillUpdateError();
    if (selectSection === "vehicle_details") {
      const date =
        updateTransporterDetails?.transporter_document_date &&
        reverseDate(updateTransporterDetails?.transporter_document_date);

      const formattedDate = date && date?.split("-")?.join("/");
      let finalData = {
        ...updateTransporterDetails,
        transporter_document_date: formattedDate,
      };
      dispatchUpdateVehicleEWayBillDetails(finalData);
    } else {
      let finalData = {
        transporter_id: trasporterId,
        token,
        invoice_id: +invoiceId,
        client_code: +clientCode,
        type: type,
        invoice_type: type,
      };
      dispatchUpdateTransporterEWayBillDetails(finalData);
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggleModal}
      backdrop="static"
      size={"lg"}
      style={{ maxWidth: "70%" }}
    >
      <ModalHeader className="pt-4 pl-4" toggle={toggleModal}>
        Update E-Way Bill Details
      </ModalHeader>
      <ModalBody className="pl-4 pr-4 form-group">
        <div>
          <label htmlFor="foldername" className={"active"}>
            Select section to update
          </label>
          <span className="color-red">*</span>
          <div className="ml-3 mt-2">
            <RadioContainer
              optionsList={VEHICLE_SECTION_RADIO_OPTIONS}
              handleSetRadioValue={handleSetSelectSection}
              radioValue={selectSection}
              alignment="horizontal"
            />
          </div>
        </div>
        <div className="mt-4 ">
          <div className="">
            {selectSection === "transporter_details"
              ? "UPDATE TRANSOPTER DETAILS"
              : "UPADTE VEHICLE DETAILS"}
          </div>
          {selectSection === "transporter_details" ? (
            <div className=" mt-3">
              <div className="col-md-5 pl-0">
                <label className={"active"}>Trasporter ID(GSTIN) </label>
                <span className="color-red">*</span>
                <input
                  type="text"
                  className={`form-control`}
                  name="text"
                  value={trasporterId}
                  onChange={(e) => handleChangeTransporterId(e)}
                />
              </div>
              {eWayBillUpdateError?.length ? (
                <div
                  className="mt-2 mb-2 error-msg p-2"
                  style={{
                    border: "1px solid #ba4916",
                    backgroundColor: "#fef2ed",
                    borderRadius: "6px",
                    width: "fit-content",
                  }}
                >
                  <span className="mr-1">
                    <img src={RedErrorIcon} alt="error" />
                  </span>
                  <span className="ml-2">{eWayBillUpdateError}</span>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            <form>
              <div className="form-group mt-3 row">
                <div className="col-md-3 ">
                  <label>Vehicle Number </label>
                  <span className="color-red">*</span>
                  <input
                    type="text"
                    className={`form-control`}
                    name="text"
                    value={updateTransporterDetails?.vehicle_number}
                    onChange={(e) => {
                      setUpdateTransporterDetails({
                        ...updateTransporterDetails,
                        vehicle_number: e.target.value,
                      });
                    }}
                  />
                </div>

                <div className="col-md-3">
                  <label>
                    State <span className="color-red">*</span>
                  </label>
                  <Select<any, false>
                    inputProps={{ autoComplete: "nope" }}
                    placeholder={"Select Mode"}
                    isLoading={stateFetching}
                    options={finalStateList}
                    value={{
                      value: updateTransporterDetails?.from_state
                        ? updateTransporterDetails?.from_state
                        : null,
                      label: updateTransporterDetails?.from_state
                        ? updateTransporterDetails?.from_state
                        : "Select...",
                    }}
                    // isLoading={userFetching}
                    onChange={(e: any) => {
                      setStateSelect(e?.id);
                      setUpdateTransporterDetails({
                        ...updateTransporterDetails,
                        from_state: e?.value,
                      });
                      setUpdateTransporterDetails({
                        ...updateTransporterDetails,
                        from_place: "",
                      });
                    }}
                    isSearchable={true}
                  />
                </div>

                <div className="col-md-3">
                  <label>
                    City <span className="color-red">*</span>
                  </label>
                  <Select<any, false>
                    inputProps={{ autoComplete: "nope" }}
                    placeholder={"Select Mode"}
                    isDisabled={
                      !updateTransporterDetails?.from_state ? true : false
                    }
                    isLoading={countryFetching}
                    options={finalCityList}
                    value={{
                      value: updateTransporterDetails?.from_place
                        ? updateTransporterDetails?.from_place
                        : null,
                      label: updateTransporterDetails?.from_place
                        ? updateTransporterDetails?.from_place
                        : "Select...",
                    }}
                    // isLoading={userFetching}
                    onChange={(e: any) => {
                      setUpdateTransporterDetails({
                        ...updateTransporterDetails,
                        from_place: e?.value,
                      });
                    }}
                    isSearchable={true}
                  />
                </div>

                <div className="col-md-3">
                  <label>
                    Reason<span className="color-red">*</span>
                  </label>
                  <Select
                    inputProps={{ autoComplete: "nope" }}
                    placeholder={"Select"}
                    // isLoading={userFetching}
                    options={REASON_CODE}
                    onChange={(e: any) => {
                      setUpdateTransporterDetails({
                        ...updateTransporterDetails,
                        reason_of_update: e?.value,
                      });
                    }}
                    isSearchable={true}
                    value={{
                      value: updateTransporterDetails?.reason_of_update
                        ? updateTransporterDetails?.reason_of_update
                        : null,
                      label: updateTransporterDetails?.reason_of_update
                        ? updateTransporterDetails?.reason_of_update
                        : "Select...",
                    }}
                  />
                </div>
              </div>
              {/* ///2nd row/ */}
              <div className="form-group mt-3 row">
                <div className="col-md-6">
                  <label>Reason Remark</label>
                  <span className="color-red">*</span>
                  <textarea
                    rows={2}
                    style={{ resize: "none" }}
                    // type="text"
                    className={`form-control`}
                    name="text"
                    value={updateTransporterDetails?.update_reason_remarks}
                    onChange={(e) => {
                      setUpdateTransporterDetails({
                        ...updateTransporterDetails,
                        update_reason_remarks: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label>Transport Document Number</label>
                  <input
                    type="text"
                    className={`form-control`}
                    name="text"
                    value={
                      updateTransporterDetails?.transporter_document_number
                    }
                    onChange={(e) => {
                      setUpdateTransporterDetails({
                        ...updateTransporterDetails,
                        transporter_document_number: e?.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label>Transport Document Date</label>
                  <div className="d-flex flex-row position-relative">
                    <div className="date-picker-wraper mr-0 w-100">
                      <Label className="mr-0 w-100">
                        <DatePicker
                          dateFormat="dd-MM-yyyy"
                          className={`form-control`}
                          selected={
                            updateTransporterDetails?.transporter_document_date
                              ? new Date(
                                  moment(
                                    `${updateTransporterDetails?.transporter_document_date}T00:00:00`,
                                    "YYYY-MM-DD"
                                  ).format("YYYY-MM-DD[T]HH:mm:ss")
                                )
                              : null
                          }
                          onChange={(e: any) => {
                            setUpdateTransporterDetails({
                              ...updateTransporterDetails,
                              transporter_document_date: e
                                ? moment(e).format("YYYY-MM-DD")
                                : null,
                            });
                          }}
                          fixedHeight
                          showMonthDropdown
                          showYearDropdown
                          placeholderText="Select"
                        />
                        <span
                          className="calender-icon"
                          style={{
                            right: "20px",
                            top: "10px",
                            cursor: "pointer",
                          }}
                        >
                          <CalenderIcon />
                        </span>
                      </Label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group mt-3 row">
                <div className="col-md-3">
                  <label>
                    Transportation Mode<span className="color-red">*</span>
                  </label>
                  <Select
                    inputProps={{ autoComplete: "nope" }}
                    placeholder={"Select"}
                    // isLoading={userFetching}
                    options={MODE}
                    onChange={(e: any) => {
                      setUpdateTransporterDetails({
                        ...updateTransporterDetails,
                        transportation_mode: e?.value,
                      });
                    }}
                    isSearchable={true}
                    value={{
                      value: updateTransporterDetails?.transportation_mode
                        ? updateTransporterDetails?.transportation_mode
                        : null,
                      label: updateTransporterDetails?.transportation_mode
                        ? updateTransporterDetails?.transportation_mode
                        : "Select...",
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label>Vehicle Type</label>
                  <Select
                    inputProps={{ autoComplete: "nope" }}
                    placeholder={"Select"}
                    // isLoading={userFetching}
                    isDisabled={
                      updateTransporterDetails?.transportation_mode !== "Road"
                    }
                    options={VEHICLE_TYPE}
                    onChange={(e: any) => {
                      setUpdateTransporterDetails({
                        ...updateTransporterDetails,
                        vehicle_type: e?.value === "Regular" ? "R" : "O",
                      });
                    }}
                    isSearchable={true}
                    value={{
                      value: updateTransporterDetails?.vehicle_type
                        ? updateTransporterDetails?.vehicle_type
                        : null,
                      label:
                        updateTransporterDetails?.vehicle_type == "R" ||
                        updateTransporterDetails?.vehicle_type == "Regular"
                          ? "Regular"
                          : updateTransporterDetails?.vehicle_type == "O" ||
                            updateTransporterDetails?.vehicle_type ==
                              "Over Dimensional Cargo"
                          ? "Over Dimensional Cargo"
                          : "Select...",
                    }}
                  />
                </div>
              </div>

              {eWayBillUpdateError?.length ? (
                <div
                  className="mt-2 mb-2 error-msg p-2"
                  style={{
                    border: "1px solid #ba4916",
                    backgroundColor: "#fef2ed",
                    borderRadius: "6px",
                    width: "fit-content",
                  }}
                >
                  <span className="mr-1">
                    <img src={RedErrorIcon} alt="error" />
                  </span>
                  <span className="ml-2">{eWayBillUpdateError}</span>
                </div>
              ) : (
                ""
              )}
            </form>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <span
          className="pointer"
          onClick={() => {
            toggleModal();
          }}
        >
          Cancel
        </span>
        <Button
          color="primary ml-3"
          onClick={() => {
            handleSubmitDetails();
          }}
          disabled={
            (selectSection === "transporter_details" &&
            !trasporterId?.trim()?.length
              ? true
              : false) ||
            (selectSection === "vehicle_details" &&
            (!updateTransporterDetails?.vehicle_number?.trim()?.length ||
              !updateTransporterDetails?.from_state?.length ||
              !updateTransporterDetails?.from_place?.length ||
              !updateTransporterDetails?.reason_of_update?.length ||
              !updateTransporterDetails?.update_reason_remarks?.trim()
                ?.length ||
              !updateTransporterDetails?.transportation_mode?.length ||
              !updateTransporterDetails?.vehicle_type?.length)
              ? true
              : false)
          }
        >
          {fetching ? "Saving..." : "Save"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  stateList: state.masterData.stateList,
  cityList: state.masterData.cityList,
  countryFetching: state.masterData.countryFetching,
  stateFetching: state.masterData.stateFetching,
  eWayBillError: state.invoiceGeneration.eWayBillError,
  eWayBillReviewData: state.invoiceGeneration.eWayBillReviewData,
  eWayBillUpdateError: state.invoiceGeneration.eWayBillUpdateError,
  fetching: state.invoiceGeneration.fetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllStateAction: (data: GetStateListDataPayloadType) =>
    dispatch(getAllStateAction(data)),
  dispatchGetAllCityAction: (data: GetCityListDataPayloadType) =>
    dispatch(getAllCityAction(data)),
  dispatchResetStateList: () => dispatch(resetStateList()),
  dispatchResetCityList: () => dispatch(resetCityList()),
  dispatchUpdateVehicleEWayBillDetails: (data: UpdateEWayBillPayloadType) =>
    dispatch(updateVehicleEWayBillDetails(data)),
  dispatchUpdateTransporterEWayBillDetails: (
    data: UpdateTrasporterEWayBillPayloadType
  ) => dispatch(updateTransporterEWayBillDetails(data)),
  dispatchResetEWayBillUpdateError: () => dispatch(resetEWayBillUpdateError()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateEWayBillDetails);
